module.exports = __webpack_public_path__ + "static/media/TAROT.b97edd22.png";